import * as React from "react"

import { cn } from "@/lib/utils"

const Marker = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex w-full justify-center", className)}
    {...props}
  />
))
Marker.displayName = "Marker"

const MarkerContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-full border border-white/10 bg-white/10 px-3.5 py-1.5 text-xs font-semibold text-white/78 shadow-sm backdrop-blur",
      className
    )}
    {...props}
  />
))
MarkerContent.displayName = "MarkerContent"

export { Marker, MarkerContent }
